// all companies
export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const FETCH_COMPANIES_SUCCESS = 'FETCH_COMPANIES_SUCCESS';
export const FETCH_COMPANIES_FAIL = 'FETCH_COMPANIES_FAIL';

// user
export const LOAD = 'LOAD';
export const LOAD_SUCCESS = 'LOAD_SUCCESS';
export const LOAD_FAIL = 'LOAD_FAIL';

export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAIL = 'FETCH_NOTIFICATIONS_FAIL';

// user companies
export const FETCH_USER_COMPANIES = 'FETCH_USER_COMPANIES';
export const FETCH_USER_COMPANIES_SUCCESS = 'FETCH_USER_COMPANIES_SUCCESS';
export const FETCH_USER_COMPANIES_FAIL = 'FETCH_USER_COMPANIES_FAIL';

export const CREATE_PROFILE = 'CREATE_PROFILE';
export const CREATE_PROFILE_SUCCESS = 'CREATE_PROFILE_SUCCESS';
export const CREATE_PROFILE_FAIL = 'CREATE_PROFILE_FAIL';

export const COMPANY_SELECTED = 'COMPANY_SELECTED';

// user profiles
export const FETCH_USER_PROFILES = 'FETCH_USER_PROFILES';
export const FETCH_USER_PROFILES_SUCCESS = 'FETCH_USER_PROFILES_SUCCESS';
export const FETCH_USER_PROFILES_FAIL = 'FETCH_USER_PROFILES_FAIL';

// toggles
export const FETCH_TOGGLES = 'FETCH_TOGGLES';
export const FETCH_TOGGLES_SUCCESS = 'FETCH_TOGGLES_SUCCESS';
export const FETCH_TOGGLES_FAIL = 'FETCH_TOGGLES_FAIL';

// employer profile
export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAIL = 'FETCH_PROFILE_FAIL';

export const FETCH_EDITABLE_PROFILE = 'FETCH_EDITABLE_PROFILE';
export const FETCH_EDITABLE_PROFILE_SUCCESS = 'FETCH_EDITABLE_PROFILE_SUCCESS';
export const FETCH_EDITABLE_PROFILE_FAIL = 'FETCH_EDITABLE_PROFILE_FAIL';

// company ads
export const FETCH_COMPANY_ADS = 'FETCH_COMPANY_ADS';
export const FETCH_COMPANY_ADS_SUCCESS = 'FETCH_COMPANY_ADS_SUCCESS';
export const FETCH_COMPANY_ADS_FAIL = 'FETCH_COMPANY_ADS_FAIL';
export const FILTER_COMPANY_ADS = 'FILTER_COMPANY_ADS';
export const CLICK_ACTIVE_AD = 'CLICK_ACTIVE_AD';

export const UPLOAD_PROFILE_BACKGROUND = 'UPLOAD_PROFILE_BACKGROUND';
export const UPLOAD_PROFILE_BACKGROUND_SUCCESS =
    'UPLOAD_PROFILE_BACKGROUND_SUCCESS';
export const UPLOAD_PROFILE_BACKGROUND_FAIL = 'UPLOAD_PROFILE_BACKGROUND_FAIL';

export const UPLOAD_PROFILE_LOGO = 'UPLOAD_PROFILE_LOGO';
export const UPLOAD_PROFILE_LOGO_SUCCESS = 'UPLOAD_PROFILE_LOGO_SUCCESS';
export const UPLOAD_PROFILE_LOGO_FAIL = 'UPLOAD_PROFILE_LOGO_FAIL';

export const UPDATE_FIELD = 'UPDATE_FIELD';
export const UPDATE_FIELD_SUCCESS = 'UPDATE_FIELD_SUCCESS';
export const UPDATE_FIELD_FAIL = 'UPDATE_FIELD_FAIL';

export const PROFILE_SET_ERRORS = 'PROFILE_SET_ERRORS';
export const PUBLISH_PROFILE = 'PUBLISH_PROFILE';
export const PUBLISH_PROFILE_SUCCESS = 'PUBLISH_PROFILE_SUCCESS';
export const PUBLISH_PROFILE_FAIL = 'PUBLISH_PROFILE_FAIL';

export const UNPUBLISH_PROFILE = 'UNPUBLISH_PROFILE';
export const UNPUBLISH_PROFILE_SUCCESS = 'UNPUBLISH_PROFILE_SUCCESS';
export const UNPUBLISH_PROFILE_FAIL = 'UNPUBLISH_PROFILE_FAIL';

// global
export const POST_FEEDBACK = 'POST_FEEDBACK';
export const POST_FEEDBACK_SUCCESS = 'POST_FEEDBACK_SUCCESS';
export const POST_FEEDBACK_FAIL = 'POST_FEEDBACK_FAIL';

// statistics
export const FETCH_STATISTICS = 'FETCH_STATISTICS';
export const FETCH_STATISTICS_SUCCESS = 'FETCH_STATISTICS_SUCCESS';
export const FETCH_STATISTICS_FAIL = 'FETCH_STATISTICS_FAIL';

// ambassadors
export const ADD_AMBASSADOR = 'ADD_AMBASSADOR';
export const ADD_AMBASSADOR_SUCCESS = 'ADD_AMBASSADOR_SUCCESS';
export const ADD_AMBASSADOR_FAIL = 'ADD_AMBASSADOR_FAIL';

export const DELETE_AMBASSADOR = 'DELETE_AMBASSADOR';
export const DELETE_AMBASSADOR_SUCCESS = 'DELETE_AMBASSADOR_SUCCESS';
export const DELETE_AMBASSADOR_FAIL = 'DELETE_AMBASSADOR_FAIL';

export const EDIT_AMBASSADOR = 'EDIT_AMBASSADOR';
export const EDIT_AMBASSADOR_SUCCESS = 'EDIT_AMBASSADOR_SUCCESS';
export const EDIT_AMBASSADOR_FAIL = 'EDIT_AMBASSADOR_FAIL';

export const UPDATE_AMBASSADOR_IMAGE = 'UPDATE_AMBASSADOR_IMAGE';
export const UPDATE_AMBASSADOR_IMAGE_SUCCESS =
    'UPDATE_AMBASSADOR_IMAGE_SUCCESS';
export const UPDATE_AMBASSADOR_IMAGE_FAIL = 'UPDATE_AMBASSADOR_IMAGE_FAIL';

// Video
export const ADD_VIDEO = 'ADD_VIDEO';
export const ADD_VIDEO_SUCCESS = 'ADD_VIDEO_SUCCESS';
export const ADD_VIDEO_FAIL = 'ADD_VIDEO_FAIL';

export const DELETE_VIDEO = 'DELETE_VIDEO';
export const DELETE_VIDEO_SUCCESS = 'DELETE_VIDEO_SUCCESS';
export const DELETE_VIDEO_FAIL = 'DELETE_VIDEO_FAIL';

export const UPDATE_VIDEO = 'UPDATE_VIDEO';
export const UPDATE_VIDEO_SUCCESS = 'UPDATE_VIDEO_SUCCESS';
export const UPDATE_VIDEO_FAIL = 'UPDATE_VIDEO_FAIL';

// Image
export const UPLOAD_IMAGE = 'UPLOAD_IMAGE';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAIL = 'UPLOAD_IMAGE_FAIL';

export const UPDATE_IMAGE = 'UPDATE_IMAGE';
export const UPDATE_IMAGE_SUCCESS = 'UPDATE_IMAGE_SUCCESS';
export const UPDATE_IMAGE_FAIL = 'UPDATE_IMAGE_FAIL';

export const REMOVE_IMAGE = 'REMOVE_IMAGE';
export const REMOVE_IMAGE_SUCCESS = 'REMOVE_IMAGE_SUCCESS';
export const REMOVE_IMAGE_FAIL = 'REMOVE_IMAGE_FAIL';

export const REORDER_IMAGE = 'REORDER_IMAGE';
export const REORDER_IMAGE_SUCCESS = 'REORDER_IMAGE_SUCCESS';
export const REORDER_IMAGE_FAIL = 'REORDER_IMAGE_FAIL';

// Occupation
export const FETCH_OCCUPATIONS = 'FETCH_OCCUPATIONS';
export const FETCH_OCCUPATIONS_SUCCESS = 'FETCH_OCCUPATIONS_SUCCESS';
export const FETCH_OCCUPATIONS_FAIL = 'FETCH_OCCUPATIONS_FAIL';

// Follow company
export const FETCH_FOLLOWER_DETAILS = 'FETCH_FOLLOWER_DETAILS';
export const FETCH_FOLLOWER_DETAILS_SUCCESS = 'FETCH_FOLLOWER_DETAILS_SUCCESS';
export const FETCH_FOLLOWER_DETAILS_FAIL = 'FETCH_FOLLOWER_DETAILS_FAIL';

export const FOLLOW_COMPANY = 'FOLLOW_COMPANY';
export const FOLLOW_COMPANY_SUCCESS = 'FOLLOW_COMPANY_SUCCESS';
export const FOLLOW_COMPANY_FAIL = 'FOLLOW_COMPANY_FAIL';

export const UNFOLLOW_COMPANY = 'UNFOLLOW_COMPANY';
export const UNFOLLOW_COMPANY_SUCCESS = 'UNFOLLOW_COMPANY_SUCCESS';
export const UNFOLLOW_COMPANY_FAIL = 'UNFOLLOW_COMPANY_FAIL';

// global broadcast
export const SHOW_BROADCAST = 'SHOW_BROADCAST';
export const REMOVE_BROADCAST = 'REMOVE_BROADCAST';

// Connected companies
export const CONNECTED_COMPANIES_FETCH_ALL = 'CONNECTED_COMPANIES_FETCH_ALL';
export const CONNECTED_COMPANIES_FETCH_ALL_SUCCESS =
    'CONNECTED_COMPANIES_FETCH_ALL_SUCCESS';
export const CONNECTED_COMPANIES_FETCH_ALL_FAIL =
    'CONNECTED_COMPANIES_FETCH_ALL_FAIL';

export const CONNECTED_COMPANIES_ADD = 'CONNECTED_COMPANIES_ADD';
export const CONNECTED_COMPANIES_ADD_SUCCESS =
    'CONNECTED_COMPANIES_ADD_SUCCESS';
export const CONNECTED_COMPANIES_ADD_FAIL = 'CONNECTED_COMPANIES_ADD_FAIL';

export const CONNECTED_COMPANIES_DELETE = 'CONNECTED_COMPANIES_DELETE';
export const CONNECTED_COMPANIES_DELETE_SUCCESS =
    'CONNECTED_COMPANIES_DELETE_SUCCESS';
export const CONNECTED_COMPANIES_DELETE_FAIL =
    'CONNECTED_COMPANIES_DELETE_FAIL';
